import React, { createContext, useCallback, useEffect, useState } from 'react';
import { getAllFonts, getAllOpenFonts } from '../utils/services/fontsAPI';
import { appendFonts } from '../utils/nodeHelpers';

export const FontsContext = createContext();

const FontsProvider = ({ children, isOpen = false }) => {
  const [ fetchingFonts, setFetchingFonts ] = useState(false);
  const [ fontList, setFonts ] = useState({});
  const [ fontMeta, setFontMeta ] = useState([]);
  const handleFonts = useCallback(async () => {
    let response = undefined;
    if (isOpen) {
      response = await getAllOpenFonts();
    } else {
      response = await getAllFonts();
    }
    if (response?.data) {
      let payload = response.data;
      setFontMeta(payload);
      const fontList = await appendFonts(payload);
      setFonts(fontList);
      setFetchingFonts(false);
    }
  }, [isOpen]);

  useEffect(() => {
    handleFonts();
  }, [handleFonts]);

  return (
    <FontsContext.Provider value={{ fetchingFonts, setFetchingFonts, fontList, handleFonts, fontMeta }}>
      {children}
    </FontsContext.Provider>
  );
};

export default React.memo(FontsProvider);